import { render, staticRenderFns } from "./PricePlan.vue?vue&type=template&id=c0f62efe&scoped=true"
import script from "./PricePlan.vue?vue&type=script&lang=js"
export * from "./PricePlan.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/style.css?vue&type=style&index=0&id=c0f62efe&prod&scoped=true&lang=css&external"
import style1 from "./PricePlan.vue?vue&type=style&index=1&id=c0f62efe&prod&scoped=true&style=scss&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0f62efe",
  null
  
)

export default component.exports